module.exports = __webpack_public_path__ + "static/img/logo-NOW_6.50e1185.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/auth/components/logo-NOW_6.png
// module id = 781
// module chunks = 2